'use strict';
const brandDialog = document.querySelector('#brand-dialog');
const contactDialog = document.querySelector('#contact-dialog');
const interest = document.querySelector('#interest');
const message = document.querySelector('#message');
let activeBrand = '';
let generatedMessage = '';

function closeMenu() {
  document.querySelector('.menu-toggle')?.setAttribute('aria-expanded', 'false');
  document.querySelector('#navigation')?.classList.remove('open');
}
function openDialog(dialog) {
  if (!dialog.open) dialog.showModal();
  document.body.classList.add('dialog-open');
}
function updateGuidance() {
  document.querySelector('#supplier-guidance').hidden = interest.value !== 'supplier';
  message.placeholder = interest.value === 'supplier'
    ? 'Introduce your company, factory location, and product specialties.'
    : 'Tell us about your company and the categories or brands you’re interested in.';
}
function openContact(role, prefill = '') {
  interest.value = role;
  if (prefill) {
    message.value = prefill;
    generatedMessage = prefill;
  } else if (message.value === generatedMessage) {
    message.value = '';
    generatedMessage = '';
  }
  updateGuidance();
  openDialog(contactDialog);
}
function showBrand(button) {
  activeBrand = button.dataset.brandName;
  document.querySelector('#brand-dialog-title').textContent = activeBrand;
  document.querySelector('#brand-dialog-type').textContent = button.dataset.brandType;
  document.querySelector('#brand-dialog-copy').textContent = button.dataset.brandCopy;
  const panel = document.querySelector('#brand-dialog-logo');
  const original = button.querySelector('.brand-logo');
  panel.replaceChildren();
  panel.hidden = !original;
  panel.classList.toggle('on-dark', button.dataset.logoDark === 'true');
  if (original) {
    const logo = original.cloneNode(true);
    logo.loading = 'eager';
    panel.append(logo);
  }
  openDialog(brandDialog);
}
// Delegation also handles sections replaced by Shopify's theme editor.
document.addEventListener('click', event => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const toggle = target.closest('.menu-toggle');
  if (toggle) {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open));
    document.querySelector('#navigation').classList.toggle('open', open);
    return;
  }
  if (target.closest('#navigation a')) closeMenu();
  const close = target.closest('.dialog-close');
  if (close) { close.closest('dialog').close(); return; }
  const brand = target.closest('[data-brand]');
  if (brand) { showBrand(brand); return; }
  const contact = target.closest('[data-contact]');
  if (contact) { openContact(contact.dataset.contact); return; }
  const category = target.closest('[data-category]');
  if (category) {
    openContact('retailer', `I would like to learn more about your ${category.dataset.category.toLowerCase()} collections.`);
    return;
  }
  if (target.closest('#brand-inquiry')) {
    brandDialog.close();
    openContact('retailer', `I would like to discuss accessory opportunities for ${activeBrand}.`);
  }
});
document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenu(); });
interest.addEventListener('change', () => {
  if (message.value === generatedMessage) {
    message.value = '';
    generatedMessage = '';
  }
  updateGuidance();
});
document.querySelectorAll('dialog').forEach(dialog => {
  dialog.addEventListener('close', () => {
    if (!document.querySelector('dialog[open]')) document.body.classList.remove('dialog-open');
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
});
// Shopify returns form status on reload. Reveal it inside the inquiry dialog.
if (document.querySelector('[data-contact-result]')) openDialog(contactDialog);
// Submission is handled by Shopify's native contact form, without interception.
